<template>
    <v-card color="grey darken-2"
            height="325"
            :style="activeModel ? 'border-left: 5px solid #070' : 'border-left: 5px solid grey'">
        <v-card-text>
            <validation-observer ref="categoriesFilterObserver" v-slot="{ invalid }">

                <v-switch
                    class="mt-0 pt-0"
                    v-model="activeModel"
                    label="Enable"
                    color="primary"
                    @change="toggled"
                ></v-switch>

                <div class="caption">Exclude any panelists who have status</div>

                <project-status-selector v-model="statusesModel"
                                         class="mt-2 mb-2"
                                         :only="['invited','started','completed']"
                                         @input="validate"
                ></project-status-selector>

                <category-picker
                    class="mt-3"
                    v-model="categoriesModel"
                    :label="categories.length === 0 ? null : 'In any of the following categories'"
                    place-holder="Click here to select categories"
                    :hint="null"
                    @input="validate"
                ></category-picker>

                <validation-provider
                    name="Number of days"
                    rules="required|integer|min_value:1|max_value:365"
                    v-slot="{ errors }">

                    <v-text-field
                        v-model="daysModel"
                        class="mt-2"
                        label="In the past"
                        placeholder="Enter # of days"
                        persistent-hint
                        hint="days"
                        style="max-width: 300px;"
                        :error-messages="errors"
                    ></v-text-field>

                </validation-provider>
            </validation-observer>
        </v-card-text>
    </v-card>
</template>

<script>

import CategoryPicker from "../../ProjectManager/components/CategoryPicker";
import ProjectStatusSelector from "./ProjectStatusSelector";

export default {

    components: {
        ProjectStatusSelector,
        CategoryPicker
    },

    props: {
        active: {
            required: true,
            type: Boolean,
            default: false,
        },
        categories: {
            required: true,
            type: Array,
        },
        statuses: {
            type: Array,
            required: false,
        },
        days: {
            type: Number,
            required: false,
            default: 31
        }
    },

    data() {
        return {
            activeModel: null,
            categoriesModel: [],
            statusesModel: [],
            daysModel: null,
            errorMessage: null,
        }
    },

    mounted() {
        this.activeModel = this.active;
        this.categoriesModel = this.categories;
        this.statusesModel = this.statuses;
        this.daysModel = this.days;
    },

    methods: {

        validate() {

            if (!this.activeModel) return;

            if (this.categoriesModel.length === 0) {
                Bus.$emit('flash-message',{
                    type: 'error',
                    message: 'Filter cannot be applied till you select at least one category',
                    location: 'bottom'
                });
                return;
            }

            this.$nextTick(() => {
                this.$refs.categoriesFilterObserver.validate()
                    .then(isValid => {

                        if (isValid) {

                            const categoryNames = this.categoriesModel.map(category => category.name);

                            this.$emit('change', {
                                excludeCategoriesActive: this.activeModel,
                                excludeCategories: categoryNames,
                                excludeCategoriesStatuses: this.statusesModel,
                                excludeCategoriesDays: parseInt(this.daysModel)
                            });

                        } else {

                            this.activeModel = false;

                            Bus.$emit('flash-message', {
                                type: 'warning',
                                message: 'Check category filter configuration',
                                location: 'bottom'
                            });
                        }
                    });
            });
        },

        toggled(enabled) {
            this.validate();
        }
    }
}
</script>
